query BIMClasses {
    bimClasses(
        filter: {
            tag: "latest"
        }
    ) {
        id

        data {
            name(language: "en") {
                text
            }
            type
        }

        metadata {
            deprecated
        }
    }
}
